export const AiStarSmall = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3213 10.4131L13.4004 10.5996L13.5869 10.6787L16.7139 12L13.5869 13.3213L13.4004 13.4004L13.3213 13.5869L12 16.7139L10.6787 13.5869L10.5996 13.4004L10.4131 13.3213L7.28516 12L10.4131 10.6787L10.5996 10.5996L10.6787 10.4131L12 7.28516L13.3213 10.4131Z'
      fill='url(#paint0_linear_10214_53596)'
      stroke='url(#paint1_linear_10214_53596)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_10214_53596'
        x1='6'
        y1='12'
        x2='18'
        y2='12'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C9EBAE' />
        <stop offset='1' stopColor='#0073B0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_10214_53596'
        x1='6'
        y1='12'
        x2='18'
        y2='12'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C9EBAE' />
        <stop offset='1' stopColor='#0073B0' />
      </linearGradient>
    </defs>
  </svg>
);
